import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class LibraryGalleryService {
  constructor(private api: ApiService) {}
  addDocumentsInOfficeLibraryForListing(payload: any) {
    return this.api.post('/library/office-library/add-document-listing-in-library', payload);
  }
  uploadLogo(payload: any) {
    return this.api.post('/office-upload-logo', payload);
  }
}
